// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"17020ed6","351":"01ec9394","453":"ce1489de","455":"a57170ab","977":"c79fb327"}[chunkId] + ".chunk.js";
};